// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"eee6bc40e9bececd","931":"5e843e6648162e5b"}[chunkId] + ".css";
};